import { Navigate, useParams } from 'react-router-dom'
import { validate as validateUuid } from 'uuid'

import { VideoAgentScreen } from 'modules/coaching/screens/VideoAgentScreen'

export const VideoAgentPage = () => {
  /* --- Section 1: Hooks --- */
  const { conversationId } = useParams<{ conversationId: string }>()

  /* --- Section 5: Early Returns --- */
  if (conversationId && !validateUuid(conversationId)) {
    return <Navigate to="/" replace />
  }

  /* --- Section 6: Render --- */
  return <VideoAgentScreen conversationId={conversationId} />
}
